// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BigWithSmallElementRow_wrapper__2vbyy"};